var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBmpMarkC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 795.058,
    height: 527.813,
    viewBox: "0 0 795.058 527.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4546",
    "data-name": "Group 4546",
    transform: "translate(-847.942 -2762.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3258",
    "data-name": "Group 3258",
    transform: "translate(588.467 2581.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19381",
    "data-name": "Path 19381",
    d: "M964.888,612.454C932.237,584.6,892.875,416.638,758.031,504.119c-69.667,45.2-187.142-38.8-284.376-9.788-89.3,26.645-97.905,114.432-89.265,143.038,17.453,57.783-36.86,66.382-87.245,91.208-79.034,38.943-20.462,177.256,54.2,177.91s526.408,0,526.408,0,108.594-2.481,153.7-62.345C1079.992,779.722,1049.224,684.393,964.888,612.454Z",
    transform: "translate(0 -198.604)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3261",
    "data-name": "Group 3261",
    transform: "translate(395.863 378.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19382",
    "data-name": "Path 19382",
    d: "M1043.09,1703.777s.946,15.253,3.9,15.471c.392.029,14.967.029,14.967.029l18.6-.108s-.122-4.483-5.56-5.43-14.541-4.769-17.835-11.957C1053.7,1694.22,1043.09,1703.777,1043.09,1703.777Z",
    transform: "translate(-918.028 -1390.313)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3258-2",
    "data-name": "Group 3258",
    transform: "translate(48.308 56.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19383",
    "data-name": "Path 19383",
    d: "M1014.763,1180.086s8.1,2.082,13.257.529,14.02,1,15.448,2.876.9,2.625-1.645,3.273-11.577,4.5-17.51,2.27-13.672-2.31-13.672-2.31Z",
    transform: "translate(-944.715 -1100.646)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19384",
    "data-name": "Path 19384",
    d: "M813.045,951.022s9.105,64.712,24.181,70.509c7.439,2.86,40.316,9.343,50.042,9.994,0,0,2.382-1.933,1.8-9.8,0,0-34.446-12.646-39.339-19.523-7.283-10.235,4.521-41.814-4.617-51.427S820.584,937.03,813.045,951.022Z",
    transform: "translate(-813.045 -941.988)",
    fill: "#4a75cb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19385",
    "data-name": "Path 19385",
    d: "M751.5,1510.75v-14.109H729.287a1.093,1.093,0,0,1-1.09-1.09v-2.26a1.093,1.093,0,0,1,1.09-1.09H751.5v-80.317a4.11,4.11,0,0,1,4.1-4.1h4.4a4.11,4.11,0,0,1,4.1,4.1V1492.2H786.3a1.093,1.093,0,0,1,1.09,1.09v2.26a1.093,1.093,0,0,1-1.09,1.09H764.091v14.109c16.072,1.215,28.948,7,32.561,14.477H718.939C722.551,1517.751,735.428,1511.965,751.5,1510.75Z",
    transform: "translate(-702.029 -1196.348)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19386",
    "data-name": "Path 19386",
    d: "M799.025,1301.8a113.452,113.452,0,0,0,8.894,12.725c9.786,12.354,20.438,22.54,22.294,32.168a43.57,43.57,0,0,0,1.72,6.163c.775,2.205,1.733,4.524,2.839,6.922,4.153,9.02,10.362,19.128,16.563,28.315,10.718,15.883,20.8,29.135,20.8,29.135l18.484-.788c-.74-1.852-8.8-23.782-19.586-50.581-4.379-10.879-9.036-22.451-13.529-33.611q-.9-2.236-1.789-4.445c-1.374-3.416-2.726-6.777-4.045-10.051-10.127-25.164-18.192-45.2-18.192-45.2s-40.473-15.332-44.676-5.4C785.332,1275.348,788.155,1283.372,799.025,1301.8Z",
    transform: "translate(-747.649 -1100.407)",
    fill: "#e58638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19387",
    "data-name": "Path 19387",
    d: "M891.454,1582.978s-12.857,8.261-11.609,10.944c.166.357,7.271,13.082,7.271,13.082l9.164,16.192s3.855-2.292,2.031-7.5-2.924-15.021,1.746-21.4C904.969,1587.58,891.454,1582.978,891.454,1582.978Z",
    transform: "translate(-809.192 -1313.088)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19388",
    "data-name": "Path 19388",
    d: "M847.15,1268.21s50.8,31.644,56.472,52.91-67.578,66.633-67.578,66.633-8.034-7.089-9.451-12.287c0,0,33.109-39.667,40.292-48.559,4.411-5.461-65.219-18.9-73.725-32.137S787.7,1270.4,787.7,1270.4Z",
    transform: "translate(-747.494 -1103.341)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1120",
    "data-name": "Rectangle 1120",
    d: "M11.331,0H100.2a11.331,11.331,0,0,1,11.331,11.331v5.693A11.332,11.332,0,0,1,100.2,28.356H11.332A11.332,11.332,0,0,1,0,17.024V11.331A11.331,11.331,0,0,1,11.331,0Z",
    transform: "translate(0 205.504)",
    fill: "#1c468a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19389",
    "data-name": "Path 19389",
    d: "M847.392,883.744a28.672,28.672,0,0,1,7.739,7.014c-12.17,3.148-32.346-8.13-32.346-8.13s7.834-5.264,10.736-16.83c.147-.584.281-1.182.4-1.794a36.543,36.543,0,0,0,.659-6.333l5.591,5.008,9.3,8.329a79.826,79.826,0,0,1-1.374,9.4Q847.789,881.965,847.392,883.744Z",
    transform: "translate(-771.227 -829.777)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19390",
    "data-name": "Path 19390",
    d: "M783.68,981.289c1.743,23.447-1.188,59.093.789,65.268,1.707,5.328,21.792,2.175,29.554.4,2.873-.658,6.353-1.6,9.948-2.711,10.025-3.1,20.949-7.537,22.121-10.828a2.779,2.779,0,0,0,.108-.379,3.011,3.011,0,0,0-.021-1.379c-.391-1.677-1.9-3.492-2.074-7.645-.2-4.637-.168-10.1-.343-15.97-.009-.661-.018-1.382-.09-2.04l0-.241c0-.126-.006-.25-.009-.376-.168-6.549-.511-13.433-.908-20.261-.253-4.288-.544-8.535-.88-12.6-.875-10.5-2.053-19.843-3.612-25.749-2.549-9.625-8.168-15.9-13.283-20.5l-3.7-3.173a21.4,21.4,0,0,1-13.424-1.788c-4.778-2.269-6.428-3.895-7.26-3.282C789.558,926.537,781.621,952.625,783.68,981.289Z",
    transform: "translate(-744.952 -869.906)",
    fill: "#739af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19391",
    "data-name": "Path 19391",
    d: "M868.477,1184.818c10.025-3.1,20.949-7.537,22.121-10.828a2.8,2.8,0,0,0,.108-.379c-.006-.46-.012-.919-.021-1.379-.39-1.677-1.9-3.492-2.073-7.645-.2-4.637-.168-10.1-.343-15.97-.009-.661-.018-1.382-.09-2.041l0-.24c0-.126-.006-.25-.009-.376L850.3,1128.786S848.116,1159.307,868.477,1184.818Z",
    transform: "translate(-789.516 -1010.435)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19392",
    "data-name": "Path 19392",
    d: "M869.788,881.011a79.83,79.83,0,0,1-1.374,9.4c-9.078-2.933-13.2-11.132-14.571-14.61-.391-.983-.561-1.59-.561-1.59s.352-.076.96-.2c1.276-.272,3.679-.781,6.25-1.325Z",
    transform: "translate(-791.549 -839.779)",
    fill: "#d68d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19393",
    "data-name": "Path 19393",
    d: "M868.865,831.146s-19.944,2.249-21.154-10.192-4.6-20.531,8.084-22.493,15.622,2.544,17.036,6.6S874.021,830.24,868.865,831.146Z",
    transform: "translate(-786.951 -790.006)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19394",
    "data-name": "Path 19394",
    d: "M837.345,805.873s1.265-16.515,19.419-18.226c12.435-1.171,5.5-11.874,4.177-13.581,0,0-9.527,1.306-19.293,2.92C821.151,780.373,835.332,803.3,837.345,805.873Z",
    transform: "translate(-776.499 -774.066)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3259",
    "data-name": "Group 3259",
    transform: "translate(108.703 105.971)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1121",
    "data-name": "Rectangle 1121",
    width: 1.836,
    height: 48.065,
    transform: "translate(50.427 46.28) rotate(-161.999)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1122",
    "data-name": "Rectangle 1122",
    width: 50.439,
    height: 3.017,
    transform: "translate(50.427 46.28) rotate(-178.776)",
    fill: "#4a75cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3260",
    "data-name": "Group 3260",
    transform: "translate(52.326 60.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19395",
    "data-name": "Path 19395",
    d: "M1000.849,1209.9s7.826,2.963,13.119,1.988,13.824,2.537,15.036,4.562.609,2.708-2,3.072-12,3.2-17.653.327-13.334-3.8-13.334-3.8Z",
    transform: "translate(-938.99 -1124.669)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19396",
    "data-name": "Path 19396",
    d: "M825.088,961.974s1.915,65.322,16.261,72.745c7.078,3.663,39.041,13.731,48.635,15.45,0,0,2.581-1.658,2.871-9.541,0,0-32.841-16.366-36.947-23.742-6.11-10.975,9.1-41.06,1.08-51.622S834.123,948.9,825.088,961.974Z",
    transform: "translate(-825.088 -954.439)",
    fill: "#739af0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1123",
    "data-name": "Rectangle 1123",
    d: "M98.557,0H227.444A98.558,98.558,0,0,1,326,98.558V323.024a98.557,98.557,0,0,1-98.557,98.557H98.557A98.557,98.557,0,0,1,0,323.024V98.557A98.557,98.557,0,0,1,98.557,0Z",
    transform: "translate(924.106 602.649) rotate(180)",
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1124",
    "data-name": "Rectangle 1124",
    width: 262.47,
    height: 334.724,
    transform: "translate(892.607 559.975) rotate(180)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3262",
    "data-name": "Group 3262",
    transform: "translate(650.046 265.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19397",
    "data-name": "Path 19397",
    d: "M2017.877,834.977h0a13.849,13.849,0,0,1-13.848-13.849V629.661a13.848,13.848,0,0,1,13.848-13.848h0a13.848,13.848,0,0,1,13.848,13.848V821.128A13.849,13.849,0,0,1,2017.877,834.977Z",
    transform: "translate(-1812.537 -554.723)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19398",
    "data-name": "Path 19398",
    d: "M1881.879,712.969h0a13.849,13.849,0,0,1-13.848-13.849V446.564a13.848,13.848,0,0,1,13.848-13.849h0a13.849,13.849,0,0,1,13.849,13.849V699.12A13.849,13.849,0,0,1,1881.879,712.969Z",
    transform: "translate(-1721.914 -432.715)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19399",
    "data-name": "Path 19399",
    d: "M1733.486,940.828h0a13.849,13.849,0,0,1-13.849-13.849V788.513a13.849,13.849,0,0,1,13.849-13.848h0a13.848,13.848,0,0,1,13.848,13.848V926.98A13.849,13.849,0,0,1,1733.486,940.828Z",
    transform: "translate(-1623.031 -660.575)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19400",
    "data-name": "Path 19400",
    d: "M1589.088,787.695h0a13.849,13.849,0,0,1-13.849-13.849V558.706a13.848,13.848,0,0,1,13.849-13.849h0a13.848,13.848,0,0,1,13.848,13.849V773.846A13.849,13.849,0,0,1,1589.088,787.695Z",
    transform: "translate(-1526.811 -507.441)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19401",
    "data-name": "Path 19401",
    d: "M1457.788,885.99V991.934a13.849,13.849,0,0,1-13.849,13.849h0a13.849,13.849,0,0,1-13.848-13.849V885.99a13.848,13.848,0,0,1,13.848-13.848h0A13.848,13.848,0,0,1,1457.788,885.99Z",
    transform: "translate(-1430.091 -725.529)",
    fill: "#ee9849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3263",
    "data-name": "Group 3263",
    transform: "translate(649.74 248.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19402",
    "data-name": "Path 19402",
    d: "M1574.331,493.452h23.456a2.426,2.426,0,0,1,0,4.853h-23.456a2.426,2.426,0,1,1,0-4.853Z",
    transform: "translate(-1524.283 -456.209)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19403",
    "data-name": "Path 19403",
    d: "M1628.621,519.916h5.342a2.426,2.426,0,0,1,0,4.853h-5.342a2.426,2.426,0,1,1,0-4.853Z",
    transform: "translate(-1560.459 -473.844)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19404",
    "data-name": "Path 19404",
    d: "M1864.02,381.829h23.456a2.426,2.426,0,1,1,0,4.853H1864.02a2.426,2.426,0,0,1,0-4.853Z",
    transform: "translate(-1717.319 -381.829)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19405",
    "data-name": "Path 19405",
    d: "M1918.31,408.293h5.342a2.434,2.434,0,0,1,2.427,2.426h0a2.434,2.434,0,0,1-2.427,2.427h-5.342a2.434,2.434,0,0,1-2.427-2.427h0A2.434,2.434,0,0,1,1918.31,408.293Z",
    transform: "translate(-1753.495 -399.463)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19406",
    "data-name": "Path 19406",
    d: "M2004.623,564.8h23.456a2.426,2.426,0,0,1,0,4.853h-23.456a2.426,2.426,0,1,1,0-4.853Z",
    transform: "translate(-1811.01 -503.755)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19407",
    "data-name": "Path 19407",
    d: "M2058.912,591.268h5.342a2.433,2.433,0,0,1,2.426,2.427h0a2.433,2.433,0,0,1-2.426,2.426h-5.342a2.434,2.434,0,0,1-2.427-2.426h0A2.434,2.434,0,0,1,2058.912,591.268Z",
    transform: "translate(-1847.185 -521.39)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19408",
    "data-name": "Path 19408",
    d: "M1721.146,723.73H1744.6a2.426,2.426,0,1,1,0,4.853h-23.456a2.426,2.426,0,0,1,0-4.853Z",
    transform: "translate(-1622.114 -609.656)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19409",
    "data-name": "Path 19409",
    d: "M1775.436,750.194h5.342a2.434,2.434,0,0,1,2.427,2.426h0a2.434,2.434,0,0,1-2.427,2.427h-5.342a2.433,2.433,0,0,1-2.426-2.427h0A2.433,2.433,0,0,1,1775.436,750.194Z",
    transform: "translate(-1658.291 -627.29)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19410",
    "data-name": "Path 19410",
    d: "M1431.6,820.911h23.456a2.427,2.427,0,1,1,0,4.853H1431.6a2.427,2.427,0,0,1,0-4.853Z",
    transform: "translate(-1429.174 -674.413)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19411",
    "data-name": "Path 19411",
    d: "M1485.89,847.375h5.342a2.426,2.426,0,1,1,0,4.853h-5.342a2.426,2.426,0,0,1,0-4.853Z",
    transform: "translate(-1465.35 -692.047)",
    fill: "#a6c7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3264",
    "data-name": "Group 3264",
    transform: "translate(421.044 344.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19412",
    "data-name": "Path 19412",
    d: "M1454.383,765.794a8.619,8.619,0,1,1,8.619-8.619A8.629,8.629,0,0,1,1454.383,765.794Zm0-13.9a5.283,5.283,0,1,0,5.283,5.283A5.289,5.289,0,0,0,1454.383,751.893Z",
    transform: "translate(-1211.532 -722.165)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19413",
    "data-name": "Path 19413",
    d: "M982.908,699.185a1.664,1.664,0,0,1-1.18-.489l-25.9-25.9H745.4a1.668,1.668,0,0,1,0-3.336H957.208l26.879,26.879a1.668,1.668,0,0,1-1.179,2.848Z",
    transform: "translate(-743.727 -669.458)",
    fill: "#2b478b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3265",
    "data-name": "Group 3265",
    transform: "translate(704.841 552.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19414",
    "data-name": "Path 19414",
    d: "M1602.942,1310.519a8.619,8.619,0,1,1,8.619-8.619A8.629,8.629,0,0,1,1602.942,1310.519Zm0-13.9a5.283,5.283,0,1,0,5.283,5.283A5.289,5.289,0,0,0,1602.942,1296.617Z",
    transform: "translate(-1594.323 -1293.281)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19415",
    "data-name": "Path 19415",
    d: "M1862,1364.675H1653.525l-26.879-26.879a1.668,1.668,0,0,1,2.359-2.359l25.9,25.9H1862a1.668,1.668,0,0,1,0,3.336Z",
    transform: "translate(-1615.536 -1321.046)",
    fill: "#2b478b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3266",
    "data-name": "Group 3266",
    transform: "translate(565.952 197.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19416",
    "data-name": "Path 19416",
    d: "M1888.7,327.4a8.619,8.619,0,1,1,8.619-8.619A8.629,8.629,0,0,1,1888.7,327.4Zm0-13.9a5.283,5.283,0,1,0,5.283,5.283A5.289,5.289,0,0,0,1888.7,313.5Z",
    transform: "translate(-1645.85 -283.775)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19417",
    "data-name": "Path 19417",
    d: "M1417.226,260.795a1.663,1.663,0,0,1-1.18-.488l-25.9-25.9H1179.713a1.668,1.668,0,1,1,0-3.336h211.813l26.879,26.879a1.668,1.668,0,0,1-1.179,2.848Z",
    transform: "translate(-1178.045 -231.068)",
    fill: "#2b478b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19418",
    "data-name": "Path 19418",
    d: "M885.7,641.008H747.453a4.226,4.226,0,0,1-4.226-4.226h0a4.226,4.226,0,0,1,4.226-4.226H885.7a4.226,4.226,0,0,1,4.226,4.226h0A4.226,4.226,0,0,1,885.7,641.008Z",
    transform: "translate(-322.35 -300.851)",
    fill: "#739af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19419",
    "data-name": "Path 19419",
    d: "M992.313,601.008h-84.86a4.226,4.226,0,0,1-4.226-4.226h0a4.226,4.226,0,0,1,4.226-4.226h84.86a4.226,4.226,0,0,1,4.226,4.226h0A4.226,4.226,0,0,1,992.313,601.008Z",
    transform: "translate(-428.967 -274.197)",
    fill: "#739af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19420",
    "data-name": "Path 19420",
    d: "M992.313,561.008h-84.86a4.226,4.226,0,0,1-4.226-4.226h0a4.226,4.226,0,0,1,4.226-4.226h84.86a4.226,4.226,0,0,1,4.226,4.226h0A4.226,4.226,0,0,1,992.313,561.008Z",
    transform: "translate(-428.967 -247.543)",
    fill: "#739af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19421",
    "data-name": "Path 19421",
    d: "M1317.122,200.03H1178.878a4.226,4.226,0,0,1-4.226-4.226h0a4.226,4.226,0,0,1,4.226-4.226h138.244a4.226,4.226,0,0,1,4.226,4.226h0A4.226,4.226,0,0,1,1317.122,200.03Z",
    transform: "translate(-609.832 -7.003)",
    fill: "#739af0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3269",
    "data-name": "Group 3269",
    transform: "translate(767.075 594.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3268",
    "data-name": "Group 3268",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309",
    "data-name": "Ellipse 309",
    cx: 30.084,
    cy: 30.084,
    r: 30.084,
    transform: "translate(0 42.545) rotate(-45)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19422",
    "data-name": "Path 19422",
    d: "M1857.576,1472.984a25.43,25.43,0,0,1,18.125,43.269l-18.125-17.838-23.763,9.07a25.447,25.447,0,0,1,23.763-34.5Z",
    transform: "translate(-1815.032 -1455.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3267",
    "data-name": "Group 3267",
    transform: "translate(45.488 29.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19423",
    "data-name": "Path 19423",
    d: "M1917.957,1510.512h10.825a.776.776,0,0,1,.773.773h0a.775.775,0,0,1-.773.773h-10.825a.776.776,0,0,1-.773-.773h0A.776.776,0,0,1,1917.957,1510.512Z",
    transform: "translate(-1917.184 -1510.512)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19424",
    "data-name": "Path 19424",
    d: "M1917.957,1517.851h10.825a.773.773,0,1,1,0,1.547h-10.825a.773.773,0,0,1,0-1.547Z",
    transform: "translate(-1917.184 -1515.402)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19425",
    "data-name": "Path 19425",
    d: "M1937,1525.19h4.47a.773.773,0,1,1,0,1.546H1937a.773.773,0,1,1,0-1.546Z",
    transform: "translate(-1929.875 -1520.293)",
    fill: "#82b378"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_19426",
    "data-name": "Path 19426",
    d: "M1829.4,1483.123l11.9-11.9h-11.9Z",
    transform: "translate(-1813.202 -1454.697)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3272",
    "data-name": "Group 3272",
    transform: "translate(879.669 605.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3271",
    "data-name": "Group 3271",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 30.084,
    cy: 30.084,
    r: 30.084,
    transform: "translate(0 60.093) rotate(-87.145)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19427",
    "data-name": "Path 19427",
    d: "M2136.643,1498.415a25.429,25.429,0,1,1,10.005,20.22l15.423-20.22-23.763,9.07A25.388,25.388,0,0,1,2136.643,1498.415Z",
    transform: "translate(-2130.527 -1466.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3270",
    "data-name": "Group 3270",
    transform: "translate(34.696 18.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19428",
    "data-name": "Path 19428",
    d: "M2223.077,1510.512H2233.9a.776.776,0,0,1,.773.773h0a.776.776,0,0,1-.773.773h-10.825a.775.775,0,0,1-.773-.773h0A.775.775,0,0,1,2223.077,1510.512Z",
    transform: "translate(-2222.304 -1510.512)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19429",
    "data-name": "Path 19429",
    d: "M2223.077,1517.851H2233.9a.773.773,0,1,1,0,1.547h-10.825a.773.773,0,0,1,0-1.547Z",
    transform: "translate(-2222.304 -1515.402)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19430",
    "data-name": "Path 19430",
    d: "M2242.123,1525.19h4.47a.773.773,0,1,1,0,1.546h-4.47a.773.773,0,0,1,0-1.546Z",
    transform: "translate(-2234.995 -1520.293)",
    fill: "#82b378"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_19431",
    "data-name": "Path 19431",
    d: "M2134.4,1483.123l11.9-11.9h-11.9Z",
    transform: "translate(-2129.034 -1465.697)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19432",
    "data-name": "Path 19432",
    d: "M1151.865,1759.039H456.34a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h695.525a1,1,0,0,1,1,1h0A1,1,0,0,1,1151.865,1759.039Z",
    transform: "translate(-130.517 -1050.159)",
    fill: "#202f4e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmpMarkC);
export default __webpack_public_path__ + "static/media/bmp-mark-c.20d0a495b52ffe181705ecc7a34da5f7.svg";
export { ForwardRef as ReactComponent };